import Construction from "../components/Construction";
function PortfolioFull() {
  return (
    <>
        <Construction />
    </>
  );
}

export default PortfolioFull;
